import { api } from "./api";
import type { CompanyResearchClient } from "./companyResearch";

export const companyResearchClient: CompanyResearchClient = {
  searchCandidates: (input) => api.searchCompanyResearchCandidates(input),
  createQuickSummary: (input) => api.createCompanyResearchQuickSummary(input),
  createJob: (input) => api.createCompanyResearchJob(input),
  getJob: (jobId) => api.getCompanyResearchJob(jobId),
  listJobs: (input) => api.listCompanyResearchJobs(input),
  listRecords: (input) => api.listCompanyResearchRecords(input),
  getRecord: (quickSummaryId) => api.getCompanyResearchRecord(quickSummaryId),
};
